import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import { useEffect, useState } from 'react';
import If from 'global/ErrorHandlers/If';
import tradingStore from 'lib/stores/trading';
import create from 'zustand';
import Link from 'next/link';
import { clevertapSecuritiesTradingPinSubmitted, clevertapSecuritiesTradingPinViewed } from 'lib/analytics/securities';

import { ButtonSubmit, LoginInfoDivider, LoginTradingModalContainer } from './styled';
import {
  AuthModalLoading,
  LoginInputPin,
  VirtualTradingButton,
} from './components';
import { AuthModalProps, AuthModalType } from './types';
import useAuthModalStore from './store';
import useLogin from './hooks/useLogin';

const useTradingStore = create(tradingStore);

export default function LoginTradingModal({ visible }: AuthModalProps) {
  const { resetErrorCode } = useTradingStore();
  const { closeModal } = useAuthModalStore();

  const [pin, setPIN] = useState('');

  const { errorMsg, setErrorMsg, loading, setLoading, onLogin } = useLogin();

  const closeLoginModal = () => {
    resetErrorCode();
    setErrorMsg('');
    closeModal();
  };

  useEffect(() => {
    setErrorMsg('');

    if (visible) {
      clevertapSecuritiesTradingPinViewed();
    }
  }, [visible]);

  return (
    <LoginTradingModalContainer
      data-cy="login-trading-modal"
      visible={visible}
      centered
      width={500}
      onCancel={closeLoginModal}
      transitionName="custom-modal"
      closeIcon={<Image src="icon/close-modal.svg" />}
    >
      <Flex direction="column" justify="center" align="center">
        <Image
          className="illustration"
          alt="securities-lock"
          src="icon/pinlogin-lock.svg"
        />

        <If condition={loading}>
          <AuthModalLoading />
        </If>

        <If condition={!loading}>
          {/* @ts-expect-error */}
          <Text size="18px" family="bold" mt="16px" mb="32px">
            Input Trading PIN
          </Text>

          <LoginInputPin
            onChangePIN={setPIN}
            errorMsg={errorMsg}
            onPressEnter={(pinValue) => onLogin(pinValue)}
          />

          <Link href="/securities/forgotpin">
            <Flex onClick={closeLoginModal}>
              <Text
                size="14px"
                family="bold"
                color={color.primary}
                // @ts-expect-error
                p="10.5px"
                mt="8px"
                mb="16px"
              >
                <a data-cy="auth-modal-forgot-pin">Forgot PIN?</a>
              </Text>
            </Flex>
          </Link>

          <Flex width="100%" justify="center" padding="20px 0 24px 0">
            <ButtonSubmit
              onClick={() => {
                onLogin(pin);
                clevertapSecuritiesTradingPinSubmitted();
              }}
              disabled={pin.length < 6}
            >
              Submit
            </ButtonSubmit>
          </Flex>
          {/* @ts-expect-error */}
          <Flex width="100%" justify="space-between" align="center" mb="26px">
            <LoginInfoDivider />
            <Text family="bold" color={color.midgray}>
              Or
            </Text>
            <LoginInfoDivider />
          </Flex>

          <VirtualTradingButton
            title="Virtual Trading"
            type={AuthModalType.LOGIN}
            setLoading={setLoading}
          />
        </If>
      </Flex>
    </LoginTradingModalContainer>
  );
}
